import { Component,OnInit,Inject,ViewChild  } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { Router } from '@angular/router';
import *  as $ from 'jquery';
import Swal from 'sweetalert2';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { DATOS_API } from 'app/auth/auth.datos';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as backInter from 'app/auth/auth-data.model';
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_izzi } from 'app/idiomas/i18n/Izzi/izzi.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_resultados_izzi } from 'app/idiomas/i18n/Izzi/resultados/resultados.lang';
import { lang_webProfile } from 'app/idiomas/i18n/webProfile/webProfile.lang';
import { WebCompProfileService } from './web-comp-profile.service';
const moment = require('moment');
const momentTz = require('moment-timezone');
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ModalCompProfileComponent } from "./modal-comp-profile/modal-comp-profile.component";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'app-web-comp-profile',
  templateUrl: './web-comp-profile.component.html',
  styleUrls: ['./web-comp-profile.component.scss'],
  animations : fuseAnimations
})
export class WebCompProfileComponent implements OnInit {
  iframe=false;
  cargando=true;
  productosAsignados:any[]=[];
  idiomaActual:string;
  offsetPipe: string;
  diferenciaUtc: number;
  urlWebComProfile:any;
  productosContratadosInter : backInter.infoProductos;
  cargandoInfoIframe:boolean=false;
  zonasUTC = zonasUTC;
  indiceZona: number;
  instUtc: number;
  instituto: string;
  labelPosition='before';
  statusWCP:boolean;
  textStatusWCP:string="Publico";
  urlCorrect:boolean;
  textWarning="";
  idiomaVideo:string;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private router: Router,
    private translateSrv: TranslateService,
    private _fuseSidebarService: FuseSidebarService,
    private snackBar: MatSnackBar,
    private wcp: WebCompProfileService,
    public dialog: MatDialog,
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_resultados.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_webProfile.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => {
      this.idiomaActual = this.translateSrv.currentLang;
      console.log('idioma Actual',this.idiomaActual);
      switch (this.idiomaActual) {
        case 'es':
          this.idiomaVideo='PERFILWEB6';
          break;
        default:
        this.idiomaVideo='WebCompanyProfile';
          break;
      }

    });
  }

  ngOnInit() {
    this.obtieneInstituto();
      this.obtieneProductosV2();
      this.idiomaActual = this.translateSrv.currentLang;
      console.log('idioma Actual',this.idiomaActual);
      switch (this.idiomaActual) {
        case 'es':
          this.idiomaVideo='PERFILWEB6';
          break;
        default:
        this.idiomaVideo='WebCompanyProfile';
          break;
      }

      // this.getGuideLinesWCP(this.instUtc,this.idiomaActual);

  }




  obtieneProductosV2(){
    let productCer:any[]=[];
    let productCerAdicionalesGeneral:any[]=[];
    let productCerAdicionalesAMCO:any[]=[];
    let productCerAdicionalesTraDig:any[]=[];
    let productCerAdicionalesPrimEmp:any[]=[];
    let productMedir:any[]=[];
    let productPulse:any[]=[];
    this.wizardService.getProductos().subscribe( (respuesta: backInter.infoProductos) => {
      console.log('respuesta',respuesta);
      this.productosContratadosInter = respuesta;
      this.productosContratadosInter.productosCertificar.sort( (a,b) => {
        if(b.fechaCertificar > a.fechaCertificar){
          return 1;
        } else{
          return -1;
        }
      });

      this.productosContratadosInter.productosCertificar.forEach(productoCer => {
        if ([1,20,40,75,70].includes(productoCer.idProducto)) {
          productCer.push(productoCer);
        }
      });
      this.cargando=false;

      this.productosAsignados=productCer;
      console.log('productCer',this.productosAsignados);




    });

  }
  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; this.instUtc = 1;  break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; this.instUtc = 2;   break;
      case '3': case 'HK': this.instituto = 'HK'; this.instUtc = 3;break;
      case '4': case 'SGP': this.instituto = 'WLDWDE'; this.instUtc = 4;  break;
      case '5': case 'TK': this.instituto = 'TK'; this.instUtc = 5;break;
      case '6': case 'FL': this.instituto = 'WLDWDE'; this.instUtc = 6;  break;
      case '11': case 'BR': this.instituto = 'WLDWDE'; this.instUtc = 11;  break;
      case '14': case 'GCTI': this.instituto = 'GCTI'; this.instUtc = 1;  break;
      case '15': case 'ES': this.instituto = 'WLDWDE'; this.instUtc = 15;  break;
      case '18': case 'AMCO': this.instituto = 'AMCO'; this.instUtc = 18;  break;
      case '22': case 'HK2': this.instituto = 'HK'; this.instUtc = 22; break;
      default: this.instituto = 'WLDWDE';
    }

    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instUtc);
    this.calculoOffsetPipe();
  }
  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }
navigateTo(idCertificar){
  this.cargandoInfoIframe=true;
  localStorage.setItem('productoIDWCP',idCertificar);
  this.getStatusPublicWebComProfile();
  this.iframe = true;
  this.mostrarIframe(true);
}

mostrarIframe(status:boolean){

  let claveIdioma =this.translateSrv.currentLang;
  console.log("entro perro",claveIdioma);
  let claveIdiomaDato:any;
  switch (claveIdioma) {
    case 'es':
      claveIdiomaDato='ES';
      break;
    case 'tr':
      claveIdiomaDato='TR';
      break;
    case 'en':
      claveIdiomaDato='EN';
      break;
    case 'zh1':
      claveIdiomaDato='ZH1';
      break;
    case 'zh2':
      claveIdiomaDato='ZH2';
      break;
    case 'pt':
      claveIdiomaDato='PT';
      break;
    case 'de':
      claveIdiomaDato='DE';
      break;
    case 'nl':
      claveIdiomaDato='NL';
      break;

    default:
      break;
  }
  this.wcp.getUrlWebComProfile(localStorage.getItem('companyID'),claveIdioma).subscribe( (respuestaUrl:any) => {
    console.log('respuestaUrl',respuestaUrl);
    if(respuestaUrl.success == true){
      if (respuestaUrl.data.out_EditURL!=null) {
        this.urlWebComProfile = respuestaUrl.data.out_EditURL;
        this.cargandoInfoIframe=false;
        this.urlCorrect=true;
        setTimeout(() => {
          $('#RecDatos').submit();
          var scrollElem= document.querySelector('#Principal');
          scrollElem.scrollIntoView();
          Swal.close();
        },1000);

      }else{
        this.cargandoInfoIframe=false;
        this.urlCorrect=false;
        this.textWarning=respuestaUrl.data.out_ResultText;
      }
    }else{
      Swal.close();
    }
  });
}

regresar(){
  this.iframe=false;
  this.urlWebComProfile="";
  this.cargandoInfoIframe=false;
  localStorage.removeItem('productoIDWCP');
}

updateStatusVisibilityWCP(event){
  console.log('event', event.checked);
  if (!event.checked) {
const dialogRef = this.dialog.open(ModalCompProfileComponent,
  {
  width: '50%',
  height: '40%',
  data: {
    productoId:localStorage.getItem('productoIDWCP'),
    status:event.checked,
    tipo:'NoStatusVisi'
  }
});
dialogRef.afterClosed().subscribe(result => {
  console.log('result',result);
  if (!result.cambio) {
    this.statusWCP=!this.statusWCP;
  }
  this.getStatusPublicWebComProfile();
});
}else{
const dialogRef = this.dialog.open(ModalCompProfileComponent,
    {
    width: '30%',
    height: '80%',
    data: {
      productoId:localStorage.getItem('productoIDWCP'),
      status:event.checked,
      tipo:'StatusVisi'
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log('result',result);
    if (!result.cambio) {
      this.statusWCP=!this.statusWCP;
    }
    this.getStatusPublicWebComProfile();
  });

}

}

helpVideo(event?){
let taghelpVideo = `<video src="${DATOS_API.urlAssets}video/${this.idiomaVideo}.mp4" autoplay poster="" style="width:100%;" controlslist="nodownload" controls></video>`;
  Swal.fire({
    html:  taghelpVideo,
    allowOutsideClick: false,
    width: '70%'
  })


}

 getStatusPublicWebComProfile(){
   let productoId=localStorage.getItem('productoIDWCP');
   this.wcp.getStatusWebComProfile(productoId).subscribe( (respuestaStatus:any) => {
     console.log('respuestaStatus',respuestaStatus);
     if(respuestaStatus.success){
       this.statusWCP=respuestaStatus.data.outWCPVisibility;
     }
   });
 }

 getGuideLinesWCP(instituto?:any,lang?:any){
   this.wcp.getGuideLineWCP(this.instUtc,this.idiomaActual).subscribe( (respuesta:any) => {
     console.log('respuesta getGuideLineWCP',respuesta);
     window.open(respuesta.guide,'_blank');
   });
 }

 getBadgesWPC(token:any){
   this.wcp.getBadgeWPC(token).subscribe( (respuesta:any) => {
     let link="https://fileserver.culturalgo.com//ReadFile?path=CertificationFilesHK/GPTW%20branding%20guideline%20ALL%20CERTIFIED%202022%20-%202023_%20EN.pdf";
     console.log('respuesta producto.tokenConfig',respuesta);
     if (respuesta.badge==null) {
       Swal.fire({
              // title: 'El archivo no está disponible',
              title: this.translateSrv.instant('WEB_COMPANY_PROFILE.MODAL.NO_DISPO_ARCHI'),
              icon: 'warning',
              // showConfirmButton:true,
              // allowOutsideClick: false
                });
     }else{
       window.open(respuesta.badge,'_blank');
     }
   });

 }












}
